/*=========================================================================================
  File Name: module-notification.js
  Description: Notification Module
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-notification-state';
import mutations from './module-notification-mutations';
import actions from './module-notification-actions';
import getters from './module-notification-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
